// extracted by mini-css-extract-plugin
export var actionRow = "_n2-6";
export var card = "_n2-0";
export var chevron = "_n2-5";
export var content = "_n2-2";
export var details = "_n2-3";
export var eventActionToggle = "_n2-4";
export var icon = "_n2-1";
export var iconBlue = "_n2-8";
export var iconBrand = "_n2-7";
export var iconGrayBlue = "_n2-9";
export var iconGreen = "_n2-a";
export var iconIndigo = "_n2-b";
export var iconOrange = "_n2-c";
export var iconPurple = "_n2-d";
export var iconRed = "_n2-e";
export var iconWarning = "_n2-f";